import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../store';
import { setBank, setPso, setUser } from '../../store/slices';
import { signOutUser } from '../../screens/login/service/auth';
import LogoutConfirmationModal from '../../components/LogoutConfirmationModal';

export default function LogoutButton() {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);

    const onLogout = async () => {
        try { await signOutUser(); } finally {
            dispatch(setPso(null));
            dispatch(setBank(null));
            dispatch(setUser(null));
            sessionStorage.removeItem('role');
            sessionStorage.removeItem('toast');
            navigate('/login');
        }
    };

    const handleConfirm = () => {
        setShowModal(false);
        onLogout();
    };

    const handleCancel = () => {
        setShowModal(false);
    };

    return (
        <>
            <div className="mt-auto p-4">
                <button
                    onClick={() => setShowModal(true)}
                    className="w-full rounded-lg border border-red-300 bg-red-50 px-3 py-2 text-sm font-medium text-red-700 transition hover:bg-red-100 dark:border-red-400/40 dark:bg-red-500/10 dark:text-red-200 dark:hover:bg-red-500/20"
                >
                    Logout
                </button>
            </div>
            <LogoutConfirmationModal
                isOpen={showModal}
                onConfirm={handleConfirm}
                onCancel={handleCancel}
            />
        </>
    );
}


